export default "__VITE_ASSET__DsYpktP$__"